module.exports = __webpack_public_path__ + "media/magic-show.0e2e9f44.mp4";